import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import { Seo } from '../components/seo';

export default function IndexPage({ data }) {
  const { nodes } = data.allMdx;

  return (
    <Layout>
      <Seo />
      <div className="mb-10">
        <h1 className="mt-0 mb-2">
          <span>📓</span> /recommends
        </h1>
        <p>
          recommends, as the name says, is a collection of recommendations with
          the purpose to guide my fellow multimedia technology students on their
          path to becoming a developer 👩‍💻
        </p>
      </div>
      <ul className="list-none flex flex-wrap gap-4 justify-center ">
        {nodes.map((page) => (
          <li
            key={page.slug}
            className="text-base text-center w-36 h-32 shadow-md transition duration-300  rounded-md cursor-pointer border-2 border-white bg-white dark:bg-gray-900 dark:border-gray-900 hover:border-yellow-500"
          >
            <a
              href={`/${page.slug}`}
              className="flex flex-col items-center justify-center no-underline px-3 w-full h-full"
            >
              {page.frontmatter.icon && <span>{page.frontmatter.icon}</span>}
              {page.frontmatter.title}
            </a>
          </li>
        ))}
      </ul>
    </Layout>
  );
}

export const query = graphql`
  query INDEX_QUERY {
    allMdx(
      sort: { fields: frontmatter___chapter }
      filter: { frontmatter: { chapter: { ne: null } } }
    ) {
      nodes {
        slug
        frontmatter {
          tags
          title
          chapter
          icon
        }
      }
    }
  }
`;
